import { Pipe, PipeTransform } from '@angular/core';
import { includes } from 'lodash';

@Pipe({
  name: 'includes',
  standalone: true,
})
export class IncludesPipe implements PipeTransform {
  public transform(array: unknown[], value: unknown): boolean {
    return includes(array, value);
  }
}
